exports = module.exports = require("../../../css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".GsZS7lS6GuC4x_iKOkB1A{width:236px}._2Fn8K4h9g9MtqFvoTKHJvL{color:\"[theme:themePrimary, default:#0078D4]\"}html[dir=ltr] ._1Qn96ILuM7FmImO90oCxSJ{padding-right:30px}html[dir=rtl] ._1Qn96ILuM7FmImO90oCxSJ{padding-left:30px}", ""]);
// Exports
exports.locals = {
	"fixWidthContextMenu": "GsZS7lS6GuC4x_iKOkB1A",
	"unscheduleText": "_2Fn8K4h9g9MtqFvoTKHJvL",
	"footerRight": "_1Qn96ILuM7FmImO90oCxSJ"
};